import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
declare let $: any;

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {
  // Properties
  objForgot: any = {
    usuario: ''
  };
  passEquals = false;
  hidePassword2 = false;
  user = '';
  email = '';
  app: string;
  message: string;
  errorValidarUsuario = false;

  objPass = {
    nueva_contrasena: '',
    confirmar_contrasena: '',
    tipo_documento: '',
    documento: '',
    id_pais: '',
    usuario: '',
    contrasena: ''
  };

  // Toogles
  state = 'usuario';
  toggleForm = false;

  // Params
  QueryToken = '';

  // Angular
  @Input() token: string;
  @Output() DataLogin: EventEmitter<object>;


  constructor( private readonly route: ActivatedRoute,
               private router: Router,
               private authService: AuthService,
               private spinner: NgxSpinnerService,
               private auth: AuthService) {
              this.app = environment.app;
              this.DataLogin = new EventEmitter();
  }

  ngOnInit() {
    if (this.token) {
      $('#modalUpdatePassword').modal('show');
    }
  }

  QueryParams() {
    this.route.queryParamMap.subscribe(queryparams => {
      this.QueryToken = queryparams.get('token');
    });
  }

  UserValidate(user: string) {
    $('#modalForgotPassword').modal('show');
    this.spinner.show();

    this.authService.validateForgotPassword(user, this.app)
        .subscribe((resp: any) => {
           this.state = 'ok';
           this.email = resp.correo;
           this.message = resp.mensaje;
           this.errorValidarUsuario = false;
           this.spinner.hide();
           (window as any).gtag('event', 'recuperar contraseña', { event_category: 'validar usuario ok' , event_label: `${user}`});
        }, (err: any) => {
           console.error( err);
           // this.state = 'error';
           this.errorValidarUsuario = true;
           this.message = err.error.message;
           this.spinner.hide();
           setTimeout(() => {
            this.errorValidarUsuario = false;
            this.objForgot.usuario = '';
           }, 5000);
           (window as any).gtag('event', 'recuperar contraseña', { event_category: 'validar usuario error' , event_label: `${user}`});
        });
  }

  Iguales(form: NgForm) {
    /*if (form.invalid) {
    return;
    }*/

    const regExp = new RegExp(/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])\S{4,16}$/);
    if (this.objPass.confirmar_contrasena.match(regExp) && this.objPass.nueva_contrasena.match(regExp) &&
      this.objPass.nueva_contrasena === this.objPass.confirmar_contrasena) {
        this.passEquals = true;
    } else {
        this.passEquals = false;
    }
  }



// Nuevo Pass Metodo
ConfirmarPassword( form: NgForm) {

  this.objPass.nueva_contrasena = encodeURIComponent(this.objPass.nueva_contrasena);
  this.objPass.confirmar_contrasena = encodeURIComponent(this.objPass.confirmar_contrasena);
  const contrasena = this.objPass.confirmar_contrasena;

  if ( form && form.invalid ) { return; }

  this.spinner.show();

  this.auth.forgotPassword(this.token, contrasena)
  .subscribe( (resp: any) => {
      $('#modalUpdatePassword').modal('hide');
      const { mensaje } = resp;
      const response = resp;
      this.spinner.hide();
      Swal.fire({
        allowOutsideClick: false,
        type: 'success',
        title: `${mensaje}` ,
        timer: 3500
      });

      setTimeout(() => {
        this.router.navigateByUrl('/login');
        const datosUsuario = { usuario: response.usuario, contrasena: response.contrasena };
        this.DataLogin.emit(datosUsuario);
     }, 2000);

  }, (err) => {
      $('#modalUpdatePassword').modal('hide');
      this.router.navigateByUrl('/login');
      this.spinner.hide();
      Swal.fire({
        type: 'error',
        title: 'Error',
        text: `${err.error.message}`
        });
      });

}

  ShowModal() {
    $('#modalForgotPassword').modal('show');
    (window as any).gtag('event', 'olvidé mi contraseña', { event_category: 'enlace' , event_label: ''});
  }

  Validar(form: NgForm) {
    if (this.passEquals === true && form.valid) {
       return true;
    } else {
      return false;
    }
  }

  togglePassword2() {
    this.hidePassword2 = !this.hidePassword2;
   }

  CloseModal() {
    $('#modalForgotPassword').modal('hide');
    this.objForgot.usuario = '';
    this.state = 'usuario';
    this.message = '';
  }

  CloseModalNewPass() {
    this.router.navigateByUrl('/login');
  }

}

